import React, { useState } from 'react';
import { Icon } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import * as Styles from './Header.style';
import LanguageDropdown from 'components/language-dropdown/LanguageDropdown';

const Header = ({ isAppDrawerOpen, onAppDrawerToggle, noOfCartItem, hanldeNavigation }) => {
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  const [language, setLanguage] = useState(i18n.language);
  const handleLanguage = async (value) => {
    setLanguage(value);
    i18n.changeLanguage(value);
  };

  return (
    <Styles.HeaderSC>
      <Styles.AppDrawerToggleButton onClick={onAppDrawerToggle}>
        <Icon name={isAppDrawerOpen ? 'close' : 'bars'} />
      </Styles.AppDrawerToggleButton>
      <Styles.RightHeader onClick={() => (isAppDrawerOpen ? onAppDrawerToggle() : {})}>
        <Styles.SocialMediaLink target="_blank " href="https://www.serverpoint.com/en/contact-us/">
          <i className="fa fa-comments" />
          <div>{t('header.string6')}</div>
        </Styles.SocialMediaLink>
        <Styles.LanguageSwitcher>
          <LanguageDropdown language={language} handleLanguage={(e) => handleLanguage(e)} isHeader />
          <Icon name="cart" onClick={hanldeNavigation} className="cart-icon" />
          <div className="noOfvs" onClick={hanldeNavigation}>
            {noOfCartItem?.length}
          </div>
        </Styles.LanguageSwitcher>
      </Styles.RightHeader>
    </Styles.HeaderSC>
  );
};
export default Header;
